import request from '@/utils/request';

// 通过类型获取网站配置
export function getHomeConfig(data) {
    return request({
        url: '/dysx/common-config/getConfigByType',
        method: 'get',
        params: data
    })
}
